import React from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const GalleryLightbox = ({ item, onClose, onPrev, onNext }) => {
  if (!item) return null;

  const handleBackdrop = () => onClose();
  const stop = (e) => e.stopPropagation();

  return (
    <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 md:p-10" onClick={handleBackdrop}>
      <button
        className="absolute top-6 right-6 w-11 h-11 rounded-full border border-white/40 text-white flex items-center justify-center hover:bg-white hover:text-[#3A4A2C] transition-colors"
        onClick={(e) => { stop(e); onClose(); }}
        aria-label="close"
      >
        <X size={20} />
      </button>

      <button
        className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-white/40 text-white flex items-center justify-center hover:bg-white hover:text-[#3A4A2C] transition-colors"
        onClick={(e) => { stop(e); onPrev(); }}
        aria-label="prev"
      >
        <ChevronLeft size={20} />
      </button>

      <button
        className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-white/40 text-white flex items-center justify-center hover:bg-white hover:text-[#3A4A2C] transition-colors"
        onClick={(e) => { stop(e); onNext(); }}
        aria-label="next"
      >
        <ChevronRight size={20} />
      </button>

      <div className="max-w-6xl w-full" onClick={stop}>
        <img src={item.src} alt={item.title} className="w-full max-h-[80vh] object-contain" />
        <div className="mt-5 text-center">
          <p className="text-white/60 text-[10px] tracking-[0.3em] uppercase mb-1">{item.category}</p>
          <h4 className="text-white font-serif text-xl">{item.title}</h4>
        </div>
      </div>
    </div>
  );
};

export default GalleryLightbox;
